module.exports = __webpack_public_path__ + "img/ic_twotone_clock@2x.efdbde74.png";